import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"

import {Page} from "@indebted/components/Page"
import {PaymentCompletedImage} from "@indebted/assets"
import {Props, Prop, PropValue, PropLabel} from "@indebted/components/Props"
import {TextToHTML} from "@indebted/components/TextToHTML"

function PaymentPlanCompleted({
	PaymentPlanInstalmentAmount,
	PaymentPlanFrequency,
	PaymentPlanStartDate,
	PaymentPlanEndDate,
	ClientName,
	I18n,
}) {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.Completed.Title}
				</Typography>
			</Grid>

			<Grid>
				<TextToHTML text={I18n.Completed.Message} align="center" className="amp-mask" />
			</Grid>

			<GridImage>
				<PaymentCompletedImage />
			</GridImage>

			<Props>
				<Prop>
					<PropLabel align="right">{I18n.Completed.PlanLabel}</PropLabel>
					<PropValue align="left">
						{PaymentPlanInstalmentAmount} {PaymentPlanFrequency}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">{I18n.Completed.PaidToLabel}</PropLabel>
					<PropValue align="left" className="amp-mask">
						{ClientName}
					</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">{I18n.Completed.StartDateLabel}</PropLabel>
					<PropValue align="left">{PaymentPlanStartDate}</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">{I18n.Completed.EndDateLabel}</PropLabel>
					<PropValue align="left">{PaymentPlanEndDate}</PropValue>
				</Prop>
			</Props>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`

export {PaymentPlanCompleted}
